import type { ActivityEvent } from '../components/domain-sections/Activity/types'
import {
  MOCK_ACTIVITY_EVENTS,
  DISPUTE_ACTIVITY_EVENTS,
  REFUND_ACTIVITY_EVENTS,
} from '@shared/data'

// ─────────────────────────────────────────────────────────────────────────────
// Entity types that have activity timelines
// ─────────────────────────────────────────────────────────────────────────────

export type ActivityEntityType =
  | 'payment'
  | 'dispute'
  | 'refund'
  | 'payment-link'
  | 'invoice'
  | 'subscription'
  | 'order'
  | 'inventory'

// ─────────────────────────────────────────────────────────────────────────────
// Config shape
// ─────────────────────────────────────────────────────────────────────────────

export interface ActivityConfig {
  events: ActivityEvent[]
  showAddComment?: boolean
  title?: string
}

// ─────────────────────────────────────────────────────────────────────────────
// Registry
// ─────────────────────────────────────────────────────────────────────────────

export const ACTIVITY_REGISTRY: Record<ActivityEntityType, ActivityConfig> = {
  payment:        { events: MOCK_ACTIVITY_EVENTS, showAddComment: true },
  dispute:        { events: DISPUTE_ACTIVITY_EVENTS, showAddComment: false, title: 'Activity' },
  refund:         { events: REFUND_ACTIVITY_EVENTS, showAddComment: false, title: 'Activity' },
  'payment-link': { events: [], showAddComment: false },
  invoice:        { events: [], showAddComment: false },
  subscription:   { events: [], showAddComment: false },
  order:          { events: [], showAddComment: false },
  inventory:      { events: [], showAddComment: false },
}

// ─────────────────────────────────────────────────────────────────────────────
// Lookup helper
// ─────────────────────────────────────────────────────────────────────────────

const EMPTY_CONFIG: ActivityConfig = { events: [] }

export function getActivityConfig(entityType?: ActivityEntityType): ActivityConfig {
  if (!entityType) return EMPTY_CONFIG
  return ACTIVITY_REGISTRY[entityType] ?? EMPTY_CONFIG
}
